import React, { useState, useEffect, useContext, useRef } from 'react';
import { LegacyStack } from '@shopify/polaris';
import LogoutButton from '../LogoutButton'
import { FormContext, FormProvider } from '@thinkwell/react.common'
import { Spinner, Form } from '@thinkwell/react.polaris'
import { ShopContext } from '../../contexts/Shop'
import { HostContext } from '../../contexts/Host'
import { CustomerContext } from '../../contexts/Customer'

export default function FreeTrial(props) {
  const form = useContext(FormContext)
  const shop_name = useContext(ShopContext)
  const host = useContext(HostContext)
  const [customer] = useContext(CustomerContext)

  const [submitting, setSubmitting] = useState(false)
  const submitExistingAccountRef = useRef(null);

  const data = {
    email: customer && customer.email,
    new_account: false,
    skus: form.field("skus")
  }

  return (<div>
    <div className="customer-info">{`${customer.first_name} ${customer.last_name}`}<br/>{customer.email}</div>
    <div>&nbsp;</div>
    <FormProvider data={data}><Form
      submitRef={submitExistingAccountRef}
      method="post"
      url={`https://${host}/accounts/free_trial?shop_name=${shop_name}`}
      onSubmitting={setSubmitting}
      onError={props.onError}
    >
      <LegacyStack>
        <Spinner active={submitting}>
          <input className="button" type="submit" value="Sign Up" onClick={() => submitExistingAccountRef.current()} disabled={!!submitting}/>
        </Spinner>
        <LogoutButton params={form.field("skus") && form.field("skus").length ? {skus: form.field("skus").join(',')} : null}/>
      </LegacyStack>
    </Form></FormProvider>
  </div>)
}
